import React, { useState } from "react";
import { Formiz, FormizStep, useForm } from '@formiz/core';
import { isNumber, isEmail, isPattern} from '@formiz/validations'
import { Field } from './Components/Field';
import { FieldSelect } from './Components/FieldSelect';
import { FieldTextArea } from './Components/FieldTextArea';
import { FieldUpload } from './Components/FieldUpload';
import { Checkbox } from './Components/Checkbox';
import Modal from "./Components/Modal";
import ReactTooltip from 'react-tooltip';
import {ConfigData} from "./config";
import CountryDropdownList from "./Components/CountryListDropdown";

const Form = () => {
  const form = useForm({ subscribe: 'form' });
  const [error, setError] = useState(false);
  const [groupNetworkShow, setGroupNetworkShow] = useState(false);
  const [internationalBrokerShow, setInternationalBrokerShow] = useState(false);
  const [otherLinesShow, setOtherLinesShow] = useState(false);
  const [agencyAgreements, setAgreementAgency] = useState("");
  const [bankruptcy, setBankruptcy] = useState("");
  const [accountsOnCompaniesHouseLabelShow, setaccountsOnCompaniesHouseLabelShow] = useState(false);
  
  const [sOFCount, SetSOFCount] = useState(0); 
  const [sOFTouched, SetSOFTouched] = useState(false); 
  const [sOFError, SetSOFError] = useState(false); 

  const [cOBCount, SetCOBCount] = useState(0); 
  const [cOBTouched, SetCOBTouched] = useState(false); 
  const [cOBError, SetCOBError] = useState(false); 

  const [isSubmitting, SetIsSubmitting] = useState(false); 
  const [submitSuccessful, SetSubmitSuccessful] = useState(false); 
  const [submitError, SetSubmitError] = useState(false); 

  const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
    });

  function handleBrokerType(e) {
    if (e === 'International Broker') {
      setInternationalBrokerShow(true)
      setGroupNetworkShow(false)
    } 
    else if (e === 'Group/Network') {
      setGroupNetworkShow(true)
      setInternationalBrokerShow(false)
    }
    else{
      setInternationalBrokerShow(false)
      setGroupNetworkShow(false)
    }
  }

  function handleSOFCheckCount(e) {
    SetSOFTouched(true);
    if (e) {
      SetSOFCount(sOFCount +1)
    } else {
      SetSOFCount(sOFCount -1)
    }
  }

  function handleCOBCheckCount(e) {
    SetCOBTouched(true);
    if (e === true) {
      SetCOBCount(cOBCount +1)
    } else {
      SetCOBCount(cOBCount -1)
    }
  }

  function modalClose(e) {
    SetSubmitSuccessful(false);
    SetSubmitError(false);
    if (submitSuccessful) {
      window.location.reload(true);
    }
  }

  const handleSubmitStep = async (event) => {
    event.preventDefault();
    if (!form.currentStep || !form.currentStep?.isValid || !form.currentStep?.name) 
    {
      setError(true);
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
    if (sOFCount === 0){
      SetSOFError(true);
      setError(true);
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
    if (cOBCount === 0){
      SetCOBError(true);
      setError(true);
      window.scrollTo({top: 0, behavior: 'smooth'})
    }
    else {
      setError(false);
    }

    form.submitStep();
    return;
  };

  const submitForm = async (values) => {
    try {
      SetIsSubmitting(true);
      SetSubmitError(false);
      values.appId = ConfigData.APP_ID;
      values.dateOfSubmission =  new Date().toISOString();
      if (values.firmsFinancialStatements !== undefined){
        values.firmsFinancialStatements = (values.firmsFinancialStatements !== null ? await toBase64(values.firmsFinancialStatements.file) : null);
      }
      if (values.firmsInsuranceBankAccountDetails !== undefined){
        values.firmsInsuranceBankAccountDetails = (values.firmsInsuranceBankAccountDetails !== null ? await toBase64(values.firmsInsuranceBankAccountDetails.file) : null);
      }
      if (values.evidenceIndemnityInsurance !== undefined){
        values.evidenceIndemnityInsurance = (values.evidenceIndemnityInsurance !== null ? await toBase64(values.evidenceIndemnityInsurance.file) : null);
      }
      if (values.regulatoryLicences !== undefined){
        values.regulatoryLicences = (values.regulatoryLicences !== null ? await toBase64(values.regulatoryLicences.file) : null);
      }
        const request = await fetch(ConfigData.API_URL, {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
           'Access-Control-Allow-Origin':'*',
           'Access-Control-Allow-Methods':'POST',
           'Ocp-Apim-Subscription-Key' : ConfigData.OCP_APIM_SUBSCRIPTION_KEY
           },
           body: JSON.stringify(values)
         });
         const response = await request.json();
         console.log('Response:' + JSON.stringify(response))
         SetIsSubmitting(false);
         if (response.status == 200){
          SetSubmitSuccessful(true);
         }
         else{
          SetSubmitSuccessful(false);
         }
       } 
       catch(error) 
       {
          SetIsSubmitting(false);
          SetSubmitError(true);
        } 
    }
 
  return (
    <div className="Tabs">

      <Modal show={submitSuccessful || submitError} handleClose={e => modalClose(e)}>
        <h2>{submitSuccessful ? 'Submit Successful' : submitError ? 'Error on Submit' : ''}</h2>
        <button className="button" onClick={e => modalClose(e)}>Close</button>
      </Modal>

      <div className="grid-container">
        <div className="tab-container">
          {form.steps.map(step => (
            <div key={step.name} className={`${step.name === form.currentStep.name ? 'numberCircle active' : 'numberCircle'}`}>
              {step.name}
            </div>
          ))}
        </div>
        <div className="tab-container tab-wording">
          <p>General Information</p>
          <p>Regulatory/Licence Status</p>
          <p>Insurance Monies</p>
        </div>
        {error &&
        <div className="tab-container error">
          <p><b>Please answer all mandatory fields highlighted</b></p>
        </div>
        }
      </div>
      <div className="outlet">
        <Formiz connect={form} onValidSubmit={submitForm}>
          <form noValidate onSubmit={handleSubmitStep}>
            <FormizStep name="1">
              <div className="row">
                <div className="column">
                  <FieldSelect
                    name="brokerType"
                    label="Broker type *"
                    required="Broker type is required"
                    placeholder="Choose a broker type..."
                    onChange={handleBrokerType}
                    options={[
                      {
                        value: 'UK Broker',
                        label: 'UK Broker',
                      },
                      {
                        value: 'International Broker',
                        label: 'International Broker',
                      },
                      {
                        value: 'Broker Appointed Representative',
                        label: 'Broker Appointed Representative',
                      },
                      {
                        value: 'MGA',
                        label: 'MGA',
                      },
                      {
                        value: 'Group/Network',
                        label: 'Group/Network',
                      }
                    ]}
                  />
                </div>
                <div className="column"></div>
              </div>
              {groupNetworkShow &&          
              <div className="row">
                <div className="column">
                <FieldSelect
                    name="brokerTypeNetworkGroup"
                    label="Type of Broker *"
                    required="Type of Broker is required"
                    placeholder="Choose a broker type..."
                    defaultValue=""
                    options={[
                      {
                        value: 'Members',
                        label: 'Members',
                      },
                      {
                        value: 'Branch',
                        label: 'Branch',
                      },
                      {
                        value: 'Subsidiary',
                        label: 'Subsidiary',
                      },
                      {
                        value: 'Franchisee',
                        label: 'Franchisee',
                      },
                    ]}
                  />
                </div>
                <div className="column">
                  <Field name="brokerGroup" label="Name of the Broker Group" required="Broker Group Name is required" />
                </div>
              </div>
              }
              <div className="row">
                <div className="column">
                  <FieldSelect
                    name="sponserType"
                    label="Sponsoring DUAL team *"
                    required="Sponsoring DUAL team is required"
                    placeholder="Choose the underwriting team who directed you to the website...."
                    defaultValue=""
                    options={[
                      {
                        value: 'Accident & Health',
                        label: 'Accident & Health',
                      },
                      {
                        value: 'Contractors\' Liability',
                        label: 'Contractors\' Liability',
                      },
                      {
                        value: 'Corporate Risks',
                        label: 'Corporate Risks',
                      },
                      {
                        value: 'Crisis Management',
                        label: 'Crisis Management',
                      },
                      {
                        value: 'Marine',
                        label: 'Marine',
                      },
                      {
                        value: 'Political Violence',
                        label: 'Political Violence',
                      },
                      {
                        value: 'Private Client',
                        label: 'Private Client',
                      },
                      {
                        value: 'Travel',
                        label: 'Travel',
                      },
                      {
                        value: 'Reinsurance',
                        label: 'Reinsurance',
                      },
                      {
                        value: 'Financial Lines',
                        label: 'Financial Lines',
                      },
                      {
                        value: 'Commercial',
                        label: 'Commercial',
                      },
                      {
                        value: 'Asset',
                        label: 'Asset',
                      },
                      {
                        value: 'Caribbean Property/Liability',
                        label: 'Caribbean Property/Liability',
                      },
                      {
                        value: 'Yacht',
                        label: 'Yacht',
                      },
                      {
                        value: 'Marine Employers Liability',
                        label: 'Marine Employers Liability',
                      },
                      {
                        value: 'Aviation',
                        label: 'Aviation',
                      },
                      {
                        value: 'No specific team',
                        label: 'No specific team',
                      }
                    ]}
                  />
                </div>
                <div className="column"></div>           
                </div>

              <div className="row">
                <div className="column">
                  <Field name="dualUnderwriter" label="DUAL underwriter contact name" />
                </div>
                <div className="column"></div>
              </div>

              <div className="row">
                <div className="column">
                  <Field name="fullLegalNameOfFirm" label="Full legal name of the firm" required="Full legal name of the firm is required" />
                </div>
                <div className="column">
                  <Field name="tradingNames" label="Trading names, assumed names or business names (All trading names)"  placeholder="If different from legal name of the firm" />
                </div>
              </div>

              <div className="row">
                <div className="column">
                <FieldTextArea name="tradingAddress" label="Trading address (All trading address)" required="Trading address is required" />
                </div>
                <div className="column">
                  <FieldSelect
                    name="registeredOffice"
                    label="Registered office country"
                    required="Registered office country is required"
                    placeholder="Choose a registered office country..."
                    options={CountryDropdownList}
                  />
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <FieldTextArea name="accountingAddress" label="Accounting address" placeholder="Including branches and accounting offices" required="Accounting address is required" />
                </div>
                <div className="column">
                  <Field name="accountingEmail" label="Accounting contact email" required="Accounting contact email is required" validations={[{rule: isEmail(), message: 'This is not a valid email',},]}/>
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <Field name="contactName" label="Contact name" required="Contact name is required" />
                </div>
                <div className="column">
                  <Field name="contactPhoneNumber" label="Contact phone number" required="Contact phone number is required" validations={[{rule: isNumber(), message: 'This is not a number',},]}/>
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <Field name="contactEmail" label="Contact email" required="Contact email is required" validations={[{rule: isEmail(), message: 'This is not a valid email',},]}/>
                </div>
                <div className="column">
                  <Field name="website" label="Website" required="Website is required" />
                </div>
              </div>
              {internationalBrokerShow &&
              <div className="row">
                <div className="column">
                  <FieldTextArea name="directors" label="Names of directors/partners/principals" required="Names of directors/partners/principals is required" />
                </div>
                <div className="column"></div>
              </div>
              }
              <div className="row">
              <label className="label-checkbox-main">Status of firm *</label>
                  <div className={`${sOFCount === 0 && (sOFTouched || sOFError) ? 'column is-error round-border' : 'column'}`}>
                    <div className='column'>
                      <Checkbox id="sof_Limited" name="sof_Limited" label="Limited" onChange={e => handleSOFCheckCount(e)}></Checkbox>
                      <Checkbox id="sof_SoleTrader" name="sof_SoleTrader" label="Sole Trader" onChange={e => handleSOFCheckCount(e)}></Checkbox>
                      <Checkbox id="sof_Partnership" name="sof_Partnership" label="Partnership" onChange={e => handleSOFCheckCount(e)}></Checkbox>
                      <Checkbox id="sof_Listed" name="sof_Listed" label="Listed" onChange={e => handleSOFCheckCount(e)}></Checkbox>
                      <Checkbox id="sof_Corporation" name="sof_Corporation" label="Corporation" onChange={e => handleSOFCheckCount(e)}></Checkbox>
                    </div>
                  </div>
                  {sOFCount === 0 && (sOFTouched || sOFError) &&
                    <div className="error-feedback-checkbox">Status of Firm is required</div>
                  }
                  <div className="column"></div>
                  </div>
                  <div className="row">
                    <div className="column">
                      <Field name="companyRegistrationNo" label="Company registration no. (e.g Companies House)" required="Company registration No is required" validations={[{rule: isNumber(), message: 'This is not a number',},]}/>
                    </div>
                </div>
              <div className="row">
              <label className="label-checkbox-main">Classes of business to be shown *</label>
                <div className={`${cOBCount === 0 && (cOBTouched || cOBError) ? 'column is-error round-border' : 'column'}`}>
                <div className="column">
                    <Checkbox id="cob_Accident&Health" name="cob_Accident&Health" label="Accident & Health" onChange={e => handleCOBCheckCount(e)}></Checkbox>
					          <Checkbox id="cob_Aviation" name="cob_Aviation" label="Aviation" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_CareHome" name="cob_CareHome" label="Care Home" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_CommercialCombined" name="cob_CommercialCombined" label="Commercial Combined" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_CommercialLegalExpenses" name="cob_CommercialLegalExpenses" label="Commercial Legal Expenses" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Contractors" name="cob_Contractors" label="Contractors" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Cyber" name="cob_Cyber" label="Cyber" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_D&O" name="cob_D&O" label="D&O" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Engineering" name="cob_Engineering" label="Engineering" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_FinancialLines" name="cob_FinancialLines" label="Financial Lines" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                  </div>
                  <div className="column">
                    <Checkbox id="cob_Forestry" name="cob_Forestry" label="Forestry" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Healthcare" name="cob_Healthcare" label="Healthcare" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_HNWHome" name="cob_HNWHome" label="HNW Home" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Liability" name="cob_Liability" label="Liability" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_PrintProtect" name="cob_PrintProtect"  label="Print Protect" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_ProfessionalIndemnity" name="cob_ProfessionalIndemnity" label="Professional Indemnity" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_PropertyOwners" name="cob_PropertyOwners" label="Property Owners" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Reinsurance" name="cob_Reinsurance" label="Reinsurance" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_Title&RealEstate" name="cob_Title&RealEstate" label="Title & Real Estate" onChange={e => handleCOBCheckCount(e)}></Checkbox>
                    <Checkbox id="cob_OtherLines" name="cob_OtherLines" label="Other Lines" onChange={e => {handleCOBCheckCount(e); setOtherLinesShow(e)}}></Checkbox>
                  </div>
                </div>
                {cOBCount === 0 && (cOBTouched || cOBError) &&
                    <label className="error-feedback-checkbox">Classes of business is required</label>
                  }
              </div>
              { otherLinesShow &&
              <div className="row">
                <div className="column">
                  <Field name="otherLines_COB_Detail" label="Please provide class of business details" required="Other lines class of business required"/>              
                </div>
                <div className="column"></div>
              </div>
               } 
              <div className="row">
                <div className="column">
                  <FieldSelect
                    name="agencyAgreements"
                    label="Is the firm party to any agency agreements or binding authorities?"
                    required="Yes or no is required"
                    placeholder="Choose yes or no..."
                    onChange={setAgreementAgency}
                    options={[
                      {
                        value: 'Yes',
                        label: 'Yes',
                      },
                      {
                        value: 'No',
                        label: 'No',
                      },
                    ]}
                  />
                </div>
                {agencyAgreements === 'Yes' &&
                <div className="column">
                  <FieldTextArea name="agencyAgreementsMore" label="Please provide details" />
                </div>
                }
              </div>
              <div className="row">
                <div className="column">
                  <FieldSelect
                    name="lloydsApprovedBroker"
                    label="Is the firm a Lloyds's approved broker?"
                    required="Yes or no is required"
                    placeholder="Choose yes or no..."
                    defaultValue=""
                    options={[
                      {
                        value: 'Yes',
                        label: 'Yes',
                      },
                      {
                        value: 'No',
                        label: 'No',
                      },
                    ]}
                  />                
                </div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                </div>
                <div className="column"></div>
              </div>
            </FormizStep>

            <FormizStep name="2">
              <div className="row">
                <div className="column">
                  <Field name="nameOfAgency" label="Name of the agency or governing authority by whom the Firm is registered or regulated" required="Name of the agency is required" />
                </div>
                <div className="column">
                  <Field name="websiteOfRegulatingBody" label="Website address of the regulating body" required="Website address of the regulating body is required" />
                </div>
              </div>
              <div className="row">
                <div className="column">
                  <FieldSelect
                    name="regulatoryCountry"
                    label="Country"
                    required="Country is required"
                    placeholder="Choose a country..."
                    options={CountryDropdownList}
                  />
                </div>
                <div className="column">
                  <Field name="registrationNumber" label="FCA Number OR Local Regulator Reference Number" required="Registration number is required"/>
                </div>
              </div>
            </FormizStep>

            <FormizStep name="3">
              <div className="row">
                <div className="column">
                <FieldSelect
                    name="premiumsInSeperateAccounts"
                    label="Are premium or other funds owned by (re)insureds and/or (re)insurers (fiduciary funds) kept in separate accounts to other funds i.e. not mingled with other funds?"
                    required="Yes or No is required"
                    placeholder="Choose yes or no..."
                    defaultValue=""
                    options={[
                      {
                        value: 'Yes',
                        label: 'Yes',
                      },
                      {
                        value: 'No',
                        label: 'No',
                      }
                    ]}
                  />
                </div>
                <div className="column">
                </div>
              </div>
              <div className="row">
                <div className="column">
                <FieldSelect
                    name="trustedAccounts"
                    label="Are these accounts trusts accounts i.e. would the beneficial owners be protected in the event of the firm's insolvency?"
                    required="Yes or no is required"
                    placeholder="Choose yes or no..."
                    defaultValue=""
                    options={[
                      {
                        value: 'Yes',
                        label: 'Yes',
                      },
                      {
                        value: 'No',
                        label: 'No',
                      }
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="column">
                <FieldSelect
                    name="bankruptcy"
                    label="Has the firm (or its principal shareholders, directors, officers, employees or persons representing the Firm) or affiliated organisation or any predecessor business filed for bankruptcy in the past five years?"
                    required="Yes or no is required"
                    placeholder="Choose yes or no..."
                    onChange={setBankruptcy}
                    options={[
                      {
                        value: 'Yes',
                        label: 'Yes',
                      },
                      {
                        value: 'No',
                        label: 'No',
                      }
                    ]}
                  />
                </div>
                {bankruptcy === 'Yes' &&
                <div className="column">
                  <FieldTextArea name="bankruptcyYes" label="If yes, please describe the circumstances" />
                </div>
                }
              </div>
              <div className="row">
                <div className="column">
                <FieldSelect
	                  name="accountsOnCompaniesHouse"
	                  label="Are your latest financial accounts available on Companies House website? (UK only). If yes, we can obtain your financial accounts from UK Companies House website."
	                  required="Yes or no is required"
	                  placeholder="Choose yes or no..."
	                  defaultValue=""
                    onChange={setaccountsOnCompaniesHouseLabelShow}
	                  options={[
                      {
                      value: 'Yes',
                      label: 'Yes',
                      },
                      {
                      value: 'No',
                      label: "No",
                      }
                    ]}
                    />
                    <br/>
                    { accountsOnCompaniesHouseLabelShow === 'No' &&
                      <label>Please attach last 2 years of your company's financial accounts or if you are a new company please provide 1 year projected Financial accounts.</label>
                    }
                  </div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                  <label>Please accompany all original supporting documents with translations in English.</label>
                </div>
              </div>
              { internationalBrokerShow &&
              <div className="row">
                <div className="column">
                  <label>The firm's latest financial statements - 2 years *</label>
                  <FieldUpload name="firmsFinancialStatements" label="If you are a new firm with less than one year of trading accounts, please provide one year of projected financials" data-tip data-for="financialTip" />
                </div>
                <ReactTooltip id="financialTip" place="top" effect="solid" className="tooltip" uuid="uuid-for-tooltip-arrow">
                  Only valid file formats are .DOC, .DOCX and .PDF
                </ReactTooltip>
                <div className="column">
                  <label>Copies of the Firm's Insurance Bank Account Details (to be provided on the Firm's headed stationery) *</label>
                  <FieldUpload name="firmsInsuranceBankAccountDetails" label="If you require us to sign a non-disclosure agreement please attach instead of financials." data-tip data-for="bankTip"/>
                </div>
                <ReactTooltip id="bankTip" place="top" effect="solid" className="tooltip" uuid="uuid-for-tooltip-arrow">
                  Only valid file formats are .DOC, .DOCX and .PDF
                </ReactTooltip>
              </div>
              }
              { internationalBrokerShow &&
              <div className="row">
                <div className="column"> 
                <FieldUpload name="evidenceIndemnityInsurance" label="Evidence of the firm's professional indemnity insurance *" data-tip data-for="evidenceTip" />              
                </div>
                <ReactTooltip id="evidenceTip" place="top" effect="solid" className="tooltip" uuid="uuid-for-tooltip-arrow">
                  Only valid file formats are .DOC, .DOCX and .PDF
                </ReactTooltip>   
                <div className="column">
                  <FieldUpload name="regulatoryLicences" label="Copies of any current regulatory/trading licences *" data-tip data-for="regulatoryTip" />    
                </div>
                <ReactTooltip id="regulatoryTip" place="top" effect="solid" className="tooltip" uuid="uuid-for-tooltip-arrow">
                    Only valid file formats are .DOC, .DOCX and .PDF
                </ReactTooltip>   
              </div>
              }
              <div className="row">
                <div className="column">
                <Field name="dateOfExpiry" label="Date of expiry of professional indemnity insurance" placeholder="DD/MM/YYYY" required="Date of expiry of professional indemnity insurance is required" validations={[{rule: isPattern('^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.]((19|20)\\d\\d)$'),message: 'Must be a valid date',},  ]}/>
                </div>
                <div className="column">
                </div>
              </div>
              <div className="row">
                <div className="column"></div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                  <Field name="submitterName" label="Submitter name" required="Name of submitter is required"/>
                </div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                <Field name="positionHeld" label="Position held" required="Position held is required"/>
                </div>
                <div className="column"></div>
              </div>
              <div className="row">
                <div className="column">
                  <label>All information submitted on this form will be kept confidential and in accordance with GDPR.</label>
                </div>
                <div className="column"></div>
                <ReactTooltip id="registerTip" place="top" effect="solid" className="tooltip">
                  Tooltip for the register button
                </ReactTooltip>
              </div>
            </FormizStep>

            {!form.isFirstStep && (
              <button type="button" className="button" onClick={form.prevStep}>
                Back
              </button>
            )}
            {form.isLastStep ? (
              <button type="submit" className="button" onClick={submitForm}>
                  {isSubmitting ?  "Submitting..." : "Submit"}
              </button>
            ) : (
              <button type="submit" className="button">
                Continue
              </button>
            )}
          </form>

        </Formiz>
      </div>
    </div>

  );
};

export default Form;